"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forceAddr = void 0;
var cardano_ledger_ts_1 = require("@harmoniclabs/cardano-ledger-ts");
function forceAddr(addr) {
    return addr instanceof cardano_ledger_ts_1.Address ? addr : cardano_ledger_ts_1.Address.fromString(addr);
}
exports.forceAddr = forceAddr;
